<template>
  <div class="pb-12 poppins">
    <div
      class="px-1 px-md-4 mb-2 mb-md-4 d-flex justify-content-center justify-content-md-end"
    >
      <div class="d-flex align-items-center">
        <DashboardWarehouseSelect :updateData="loadInitialDataFromServer" />

        <v-icon size="44" color="pink" @click="toggleModal"
          >mdi-fullscreen</v-icon
        >
      </div>
    </div>

    <template v-if="itemIndex > -1">
      <DashboardFloorPerformanceGroup
        :serverData="serverData"
        :group="group"
        v-if="itemIndex > 0"
      />
      <DashboardFloorOperationGroup :serverData="group" v-else />
    </template>

    <v-dialog v-model="dialog" fullscreen>
      <div
        style="
          background-color: #ebedf3;
          min-height: fit-content;
          height: 100vh;
          width: 100%;
          position: relative;
          overflow-y: hidden !important;
        "
        class="pt-16 pt-md-0 pb-8 pb-0"
      >
        <div class="h-100 zindex-5 scroll-y">
          <div
            class="px-1 px-md-4 pt-2 pb-0 position-absolute"
            style="
              display: flex;
              justify-content: end;
              bottom: -100px;
              right: 0;
            "
          >
            <v-icon x-large color="pink" @click="toggleModal"
              >mdi-fullscreen-exit</v-icon
            >
          </div>

          <template v-if="itemIndex > -1">
            <DashboardFloorPerformanceGroup
              :serverData="serverData"
              :group="group"
              v-if="itemIndex > 0"
            />
            <DashboardFloorOperationGroup :serverData="group" v-else />
          </template>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import DashboardFloorPerformanceGroup from "@/own/components/dashboard/DashboardFloorPerformanceGroup.vue";
import DashboardWarehouseSelect from "@/own/components/dashboard/DashboardWarehouseSelect.vue";
import DashboardFloorOperationGroup from "@/own/components/dashboard/DashboardFloorOperationGroup.vue";
import {
  SET_WAREHOUSE,
  SET_WAREHOUSES_LIST,
} from "@/core/services/store/auth.module";

export default {
  name: "DashboardFloor",
  components: {
    DashboardFloorPerformanceGroup,
    DashboardFloorOperationGroup,
    DashboardWarehouseSelect,
  },
  data: () => ({
    dialog: false,
    serverData: [],
    group: [],
    refreshDataIntervalId: null,
    groupIntervalId: null,
    itemIndex: -1,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.loadInitialDataFromServer();
    this.startAutoRefresh();
    setTimeout(() => {
      this.dialog = true;
    }, 1000);
  },
  beforeDestroy() {
    this.stopIntervals();
  },
  // watch: {
  //   itemIndex(val) {
  //     console.log(val);
  //     console.log("this.group", this.group);
  //   },
  // },
  methods: {
    startAutoRefresh() {
      this.refreshDataIntervalId = setInterval(() => {
        this.loadInitialDataFromServer(
          true,
          this.$store.getters.getSelectedWarehouse
        );
      }, 300000);
    },
    refreshGroupItems() {
      // console.log(this.serverData);
      this.groupIntervalId = setInterval(() => {
        this.group = this.serverData[this.itemIndex];
        this.itemIndex = (this.itemIndex + 1) % this.serverData.length; // Loop back to 0 after the last item
      }, 30000);
    },
    stopIntervals() {
      clearInterval(this.refreshDataIntervalId);
      clearInterval(this.groupIntervalId);
    },
    toggleModal() {
      this.dialog = !this.dialog;
    },
    loadInitialDataFromServer(forAutoRefresh = false, param = null) {
      let filterData = {
        date_range_type: "custom",
        date_range: ["2021-01-15", "2021-02-14"],
      };

      let url = param
        ? `/dashboards/dashboardFloor?warehouse_id=${param}`
        : "/dashboards/dashboardFloor";

      ApiService.post(url, filterData)
        .then((response) => {
          // console.log(response.data);
          // this.serverData = response.data;

          this.serverData = response.data.data[0];

          if (!forAutoRefresh) {
            this.$store.commit(
              SET_WAREHOUSE,
              response.data.selected_warehouse_id
            );
            this.$store.commit(SET_WAREHOUSES_LIST, response.data.warehouses);
          }
          this.$store.commit(SET_PAGE_LOADING, false);
        })
        .catch((error) => {})
        .finally(() => {
          if (this.itemIndex === -1) {
            this.itemIndex = 0;
            this.group = this.serverData[this.itemIndex];
            this.itemIndex = (this.itemIndex + 1) % this.serverData.length; // Loop back to 0 after the last item
            this.refreshGroupItems();
          }
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
  },
};
</script>
